export default __webpack_public_path__ + "static/media/show-lamp-2.cbd833ce.webp";